import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function ciudadComboReducer(state= initialState.ciudadCombo, action){
	switch(action.type){
		case types.GET_CIUDADS_COMBO_SUCCESS:		            
			return action.datos;		
	
		default:
			return state;
	}
}